import React from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const OtpVerified = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card
        sx={{
          marginTop: "1rem",
          padding: "1rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MDTypography color="success" fontSize="100px">
          <CheckCircleIcon color="inherit" fontSize="inherit" />
        </MDTypography>

        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            rowGap: "1rem",
          }}
        >
          <MDTypography sx={{ fontSize: "24px", fontWeight: "bold" }}>
            OTP Verified
          </MDTypography>

          <MDTypography sx={{ fontSize: "20px", fontWeight: "bold" }}>
            Your claim is requested and will be processed within 24 hours
          </MDTypography>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default OtpVerified;
